/**
 * Created by saeed on 2/5/2017.
 */
import { Injectable }     from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import {Observable} from 'rxjs/Rx';

import {TranslateService} from 'ng2-translate';

// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {MatSnackBar,MatSnackBarConfig} from '@angular/material';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {Direct} from "../../../../node_modules/protractor/built/driverProviders/direct";
import {DialogFormComponent} from "../../component/shared/dialog-form/dialog-form.component";

enum AlertType
{
  Success,
  Info,
  Warning,
  Error,
  Wait
}
@Injectable()
export class AlertService {

  private no_connection_error_message:string="خطا در ارتباط با سرور . لطفا اتصال به اینترنت را چک کنید و مجددا تلاش کنید.";
  constructor(private translate:TranslateService, public snackBar:MatSnackBar,public dialog:MatDialog) {


  }

  showErrorMessage(msg:string, title?:string) {
    if (!title)title = 'خطا';
    this.addToast(title, msg, AlertType.Error);

  }

  showSuccessMessage(msg:string, title?:string) {
    if (!title)title = '';
    this.addToast(title, msg, AlertType.Success);

  }

  showInfoMessage(msg:string, title?:string) {
    if (!title)title = '';

    this.addToast(title, msg, AlertType.Info);

  }

  addToast(title:string, message:string, type:AlertType) {
    let config:MatSnackBarConfig = new MatSnackBarConfig();
    config.announcementMessage = "test announcementMessage";
    config.duration = 5000;
    config.extraClasses = ['snackMessage'];
   /* if(message=='Server error')
    {
      message=this.no_connection_error_message;
    }*/
    try {
      message = this.translate.instant(message);
    }catch(error)
    {
      message =this.no_connection_error_message;
    }
    switch (type) {
      case AlertType.Error:
      {
        config.duration = 8000;
        config.extraClasses = ['snackMessage', 'errorMessage'];
        this.snackBar.open(message, 'X', config);
        break;
      }
      case AlertType.Info:
      {
        config.extraClasses = ['snackMessage', 'infoMessage'];
        this.snackBar.open(message, 'X', config);
        break;
      }
      case AlertType.Success:
      {
        config.extraClasses = ['snackMessage', 'successMessage'];
        this.snackBar.open(message, 'X', config);
        break;
      }
      case AlertType.Wait:
      {
        this.snackBar.open(message, 'X', config);
        break;
      }
      case AlertType.Warning:
      {
        config.extraClasses = ['snackMessage', 'warningMessage'];
        this.snackBar.open(message, 'X', config);
        break;
      }
    }
    /* this.translate.get(message).subscribe((msg)=>{
     message=msg;
     var toastOptions:ToastOptions = {
     title: title,
     msg: message,
     showClose: true,
     timeout: 8000,
     theme: 'default',
     onAdd: (toast:ToastData) => {
     },
     onRemove: function (toast:ToastData) {
     }
     };
     // Add see all possible types in one shot
     switch (type) {
     case AlertType.Error:
     {
     toastOptions.timeout=15000;
     this.toastyService.error(toastOptions);

     break;
     }
     case AlertType.Info:
     {
     toastOptions.timeout=10000;
     this.toastyService.info(toastOptions);

     break;
     }
     case AlertType.Success:
     {
     this.toastyService.success(toastOptions);

     break;
     }
     case AlertType.Wait:
     {
     this.toastyService.wait(toastOptions);

     break;
     }
     case AlertType.Warning:
     {
     this.toastyService.warning(toastOptions);

     break;
     }
     }

     });*/
    // Or create the instance of ToastOptions

  }

  public showDialog(title,text):void {
    let dialogRef = this.dialog.open(DialogFormComponent, {
      width: '400px',
      data: {dialogContent: text,dialogTitle: title}
    });
    dialogRef.afterClosed().subscribe(result => {


    });
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/services/alert/alert.service.ts